import clsx from 'clsx'
import {AirbnbLogo, ExpediaLogo, GoogleLogo, IBMLogo} from '~/ui/Illustrations'

export function CustomersLogos({className}: {className?: string}) {
  return (
    <div className={clsx('flex flex-wrap items-center gap-7', className)}>
      <GoogleLogo />
      <IBMLogo />
      <AirbnbLogo />
      <ExpediaLogo />
    </div>
  )
}
